<template>
  <div id="SelectProject" class="w-h rPos fCenter fCol blackFont" >
    <h2 style="margin-bottom:18px;" >
      <span class="el-icon-s-promotion" > 选择您需要进入的项目</span>
    </h2>
    <div class="rPos">
      <span class="el-icon-arrow-left aPos cPointer hover" style="bottom: calc(100% + 21px);left: 0px;font-size: 16px;"
        @click.stop="$route.meta.from.rootpage ? window.App.Gorootpage() : $router.back()"
        >{{ $route.meta.from.rootpage ? ' 重新登录' : ' 返回' }}</span>
      <mytable
        class='visitable'
        style='width: 90vw;border-radius: 12px;overflow: hidden;'
        v-s:250.opacity='boolean ? 1 : (window.sleep.clear(30,v=>boolean=true),0)'
        :tableColums='tableColums'
        :nowData="projectUserList||[]"
        api=''
        xupdateapi='updateDepartment'
        x:height="H-100"
        >
         
      </mytable>
    </div>
  </div>
</template>
<script>
import myhttp from "../utils/myhttp.js";
import api from "../utils/api.js";
import qs from "qs";
export default {
  data() {
    return {
      projectUserList:[],
      tableColums: {
        $selection: false,
        projectName : ["项目名称"],
        srName : ["区域"],
        projectRemark: ['项目描述'],
        createtime: [ "创建时间", 200 ],
        $operation: [
          "操作", 160,
          `@text: 进入项目#(--Colorlight)
           @click:
            A.local('$projectId',$row.projectId);
            A.local('$projectName',$row.projectName);
            A.local('$srName',$row.srName);
            $Loading('正在进入'), A.relogin().then(v=>(A.doLogin($row.projectName),$Loaded(),location.reload()));
          `,
        ],

      },

    };
  },

  async created() {
    
   
    const data = {
          currentPage: 1,
          pageSize: 0,
          }
        var s = qs.stringify(data);
        const responseData = await myhttp.postFileUsers(api.getUserProjectList, s);
          this.projectUserList=responseData.data.data.projectUserList;
       console.log(this.projectUserList,this.$refs.MyTable.tableData)
       

   
  },
  methods:{
    async getData(){
      
    }
  },
  activated() {
  },

  mounted: function() {
    
    document.title = '选择您需要进入的项目';
  },
};

</script>


<style scoped >
  #SelectProject {
    /*color:#f4f4f4;*/
    color: var(--Themecolor);
    background: rgba(var(--rcolor),var(--gcolor),var(--bcolor),0.1);
  }
  .visitable {
    box-shadow: 0 2px 2px 0 rgba(var(--rcolor),var(--gcolor),var(--bcolor), 0.14), 0 1px 5px 0 rgba(var(--rcolor),var(--gcolor),var(--bcolor), 0.12), 0 3px 1px -2px rgba(var(--rcolor),var(--gcolor),var(--bcolor), 0.4)
  }
</style>



// WEBPACK FOOTER //
// src/views/SelectProject.fullscreen.Notkeepalive.vue